import { FOSSABOT_DEP_UPGRADE_PRS } from '../../../../../shared/featureFlags/flagNames';
import { useIsFeatureEnabled } from '../../../../helpers/features';
import { Action, ResourceType, useHasPermission } from '../../../../shared/permissions';

/**
 * Whether the fossabot Remediation panel should replace the old Remediation
 * section for the active vulnerability issue.
 *
 * The gate is the fossabot dependency upgrade PRs flag plus View permission on
 * fossabot upgrades. It lives here so the drawer and the full page issue
 * details view stay in agreement, and so a future gate change lands once.
 */
export const useShouldShowFossabotRemediation = (): boolean => {
  const isFossabotEnabled = useIsFeatureEnabled(FOSSABOT_DEP_UPGRADE_PRS);
  const hasPermission = useHasPermission();

  return isFossabotEnabled && hasPermission({
    action: Action.View,
    resourceType: ResourceType.OrganizationFossabotUpgrade,
  });
};
